// extracted by mini-css-extract-plugin
module.exports = {"circleSpinner":"CircleSpinner_circleSpinner__32FBk","circleSpinner__item":"CircleSpinner_circleSpinner__item__17RBT","spinner":"CircleSpinner_spinner__297WF"};